import { useParams } from "react-router-dom";
import { createWPFileLink } from "../../helpers/urlBuilder";
import GeneralHeader from "../../components/GeneralHeader";
import Footer from "../../components/Footer";
import Layout from "../Layout";
import { Grid2, Typography } from "@mui/material";
import AutoDownloader from "../../components/AutoDownloader";

import classes from "./index.module.scss";

const WhitePaperPage = () => {
  const { name } = useParams();

  return <Layout
    header={<GeneralHeader />}
    center={(
      <Grid2
        container
        className={classes.container}
        direction="column"
        spacing={8}
      >
        <>
          <Grid2>
            <Typography variant='h1'>Whitepaper download</Typography>
          </Grid2>
          <Grid2>
            <AutoDownloader fileUrl={createWPFileLink(name)} errorText={'Download failed. Whitepaper doesn\'t exist'} />
          </Grid2>
        </>
      </Grid2>
    )}
    footer={<Footer />}
  />
}

export default WhitePaperPage;